<script>
export default {
    name: "BalanceSheet",

    data() {

        return {
           orderval:0,
            filter: {
                userName: this.$root.username,
                balanceSheetDetails: [
                    {
                        asAt: this.$moment().format(`YYYY-MM-DD`),
                    },
                ]
            },
            defaultFilter: 1,
            bls:{
 balanceSheetDetails: []
            }
           ,
            fps: [],
        };
    },

    computed: {

        totalBalance() {
            if(!this.bls.balanceSheetDetails.length) return 0;

            return this.bls.balanceSheetDetails.map(bal => bal.value ? bal.value : 0).reduce((sum, amt) => sum + amt);
        },
         groups() {
            if(!this.bls.balanceSheetDetails.length) return [];

            let groups = this.bls.balanceSheetDetails.map(bls => bls.groupId);

            let groupsSet = new Set(groups);

            return Array.from(groupsSet);
        },
    },

    watch: {
        defaultFilter() {

            switch (this.defaultFilter) {
                    case 1: 
                        this.filter.balanceSheetDetails = [{
                                asAt: this.$moment().format(`YYYY-MM-DD`),
                            }];
                        break;
                    case 2:
                        this.filter.balanceSheetDetails = [{
                                asAt: this.$moment().format(`YYYY-MM-DD`),
                            }];
                        this.filter.balanceSheetDetails.push({
                            asAt: null,
                        });
                        break;
                    case 3:
                        this.filter.balanceSheetDetails = [{
                                asAt: this.$moment().format(`YYYY-MM-DD`),
                            }];
                        this.filter.balanceSheetDetails.push(...[
                            {
                                asAt: null,
                            },
                            {
                                asAt: null,
                            },
                        ]);
                        break;
                    case 4:
                        this.filter.balanceSheetDetails = [{
                                asAt: this.$moment().format(`YYYY-MM-DD`),
                            }];
                        this.filter.balanceSheetDetails.push(...[
                            {
                                asAt: null,
                            },
                            {
                                asAt: null,
                            },
                            {
                                asAt: null,
                            },
                        ]);
                        break;
                    default:
                        break;
                }
        },
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchFinancialPeriods(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchBalanceSheet() {
            let url = `Accounting/BalanceSheet`;

            return this.$http.post(url, this.filter).then(({ data }) => {
                this.bls = data;
            }).catch(() => {});
        },

        fetchFinancialPeriods() {

            return this.$http.get(`Accounts/GetFinancialPeriods`).then(({ data }) => {
                this.fps = data;
            }).catch(() => {});
        },

        printBalanceSheet() {
            let url = `/finance-dashboard/coas/balance-sheet/print`;
                url += `?from=${this.filter.from}`;
    
            window.open(url, `_blank`, `PrintBalanceSheet`);
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <div class="w-full flex flex-wrap items-center">
        <div class="md:w-1/6 w-full p-tiny">
            <label for="grid-depth" class="label-control">Depth</label>
            <tail-select>
                <template v-slot:field>
                    <select id="grid-depth" v-model="defaultFilter" class="input-control input-sm text-xs">
                        <option :value="1">Default</option>
                        <option :value="2">Two</option>
                        <option :value="3">Three</option>
                        <option :value="4">Four</option>
                    </select>
                </template>
            </tail-select>
        </div>
        <div class="md:w-4/6 w-full p-tiny flex flex-row">
            <div 
                v-for="(dateFilter, idx) in filter.balanceSheetDetails" :key="idx"
                class="w-1/5 flex flex-col">
                <div class="w-full p-tiny">
                    <label class="label-control">Period</label>
                    <tail-select>
                        <template v-slot:field>
                            <select id="" class="input-control input-sm text-xs">
                                <option :value="0">select period</option>
                                <option v-for="fp in fps" 
                                    :key="fp.periodId" :value="fp.periodId">{{ fp.periodYr }}</option>
                            </select>
                        </template>
                    </tail-select>
                </div>
                <div class="w-full p-1">
                    <label for="grid-date-from" class="label-control">As at:</label>
                    <input type="date" v-model.trim="dateFilter.asAt" 
                        id="grid-date-from" class="input-control input-sm text-xs">
                </div>
            </div>
        </div>
        <div class="md:w-1/6 w-full p-1">
            <button 
                @click.prevent="() => {
                    $root.loading = true;
                    fetchBalanceSheet().then(() => {
                        $root.loading = false;
                    });
                }"
                class="btn-sm btn-primary text-xs rounded mt-4">Filter</button>
        </div>
    </div>
    <!-- Previous balance sheet view -->
        <!-- <div class="w-full overflow-auto" style="max-height:35rem;">
            <table class="table border" id="table-balance-sheet">
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                Assets</th>
                            <th class="py-tiny whitespace-nowrap"></th>
                        </tr>
                    </thead>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                Fixed Assets</th>
                            <th class="py-tiny whitespace-nowrap"></th>
                        </tr>
                    </thead>
                    <tbody class="bg-gray-100 text-sm border-b-2">
                        <tr class="border-b-2" 
                            v-for="(balance, idx) in balances.filter(bal => bal.sortname == ` Fixed Assets`)" 
                            :key="`_4_${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="py-tiny">
                                {{ balance.particulars }}
                            </td>
                            <td class="py-tiny">
                                {{ balance.value ? $formatCurrency(balance.value) : '0.00' }}
                            </td>
                        </tr>
                    </tbody>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                Total Fixed Assets</th>
                            <th class="py-tiny whitespace-nowrap">
                                {{
                                    balances.filter(bal => bal.particulars == `Total Fixed Assets`).length
                                    ?
                                    $formatCurrency(balances.filter(bal => bal.particulars == `Total Fixed Assets`)[0].value)
                                    :
                                    '0.00'
                                }}
                            </th>
                        </tr>
                    </thead>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                Current Assets</th>
                            <th class="py-tiny whitespace-nowrap"></th>
                        </tr>
                    </thead>
                    <tbody class="bg-gray-100 text-sm border-b-2">
                        <tr class="border-b-2" 
                            v-for="(balance, idx) in balances.filter(bal => bal.sortname == `Current Assets`)" 
                            :key="`_2_${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="py-tiny">
                                {{ balance.particulars }}
                            </td>
                            <td class="py-tiny">
                                {{ balance.value ? $formatCurrency(balance.value) : 0.00 }}
                            </td>
                        </tr>
                    </tbody>
                    <tbody class="bg-gray-100 text-sm border-b-2">
                        <tr class="border-b-2" 
                            v-for="(balance, idx) in balances.filter(bal => bal.particulars == `Other Assets`)" 
                            :key="`_12_${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="py-tiny">
                                {{ balance.particulars }}
                            </td>
                            <td class="py-tiny">
                                {{ balance.value ? $formatCurrency(balance.value) : 0.00 }}
                            </td>
                        </tr>
                        <tr class="border-b-2">
                            <th class="py-tiny whitespace-nowrap">
                                Total Current Assets</th>
                            <th class="py-tiny whitespace-nowrap">
                                {{
                                    balances.filter(bal => bal.particulars == `Total Current Assets`).length
                                    ?
                                    $formatCurrency(balances.filter(bal => bal.particulars == `Total Current Assets`)[0].value)
                                    :
                                    '0.00'
                                }}
                            </th>
                        </tr>
                        <tr class="border-b-2" 
                            v-for="(balance, idx) in balances.filter(bal => bal.particulars == `Total Other  Assets`)" 
                            :key="`_02_${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="py-tiny">
                                {{ balance.particulars }}
                            </td>
                            <td class="py-tiny">
                                {{ balance.value ? $formatCurrency(balance.value) : 0.00 }}
                            </td>
                        </tr>
                    </tbody>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                Total Assets</th>
                            <th class="py-tiny whitespace-nowrap">
                                {{
                                    balances.filter(bal => bal.particulars == `TOTAL ASSETS`).length
                                    ?
                                    $formatCurrency(balances.filter(bal => bal.particulars == `TOTAL ASSETS`)[0].value)
                                    :
                                    '0.00'
                                }}
                            </th>
                        </tr>
                    </thead>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                Liabilities</th>
                            <th class="py-tiny whitespace-nowrap">
                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-gray-100 text-sm border-b-2">
                        <tr class="border-b-2" 
                            v-for="(balance, idx) in balances.filter(bal => bal.sortname == ` Current Liabilities`)" 
                            :key="`_022_${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="py-tiny">
                                {{ balance.particulars }}
                            </td>
                            <td class="py-tiny">
                                {{ balance.value ? $formatCurrency(balance.value) : 0.00 }}
                            </td>
                        </tr>
                    </tbody>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                Total Current Liabilities</th>
                            <th class="py-tiny whitespace-nowrap">
                                {{
                                    balances.filter(bal => bal.particulars == `Total Current Liabilities`).length
                                    ?
                                    $formatCurrency(balances.filter(bal => bal.particulars == `Total Current Liabilities`)[0].value)
                                    :
                                    '0.00'
                                }}
                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-gray-100 text-sm border-b-2">
                        <tr class="border-b-2" 
                            v-for="(balance, idx) in balances.filter(bal => bal.particulars == ` Long Term Liabilities`)" 
                            :key="`_021_${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="py-tiny">
                                {{ balance.particulars }}
                            </td>
                            <td class="py-tiny">
                                {{ balance.value ? $formatCurrency(balance.value) : 0.00 }}
                            </td>
                        </tr>
                    </tbody>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                Total Long Term Liabilities</th>
                            <th class="py-tiny whitespace-nowrap">
                                {{
                                    balances.filter(bal => bal.particulars == `Total Long Term Liabilities`).length
                                    ?
                                    $formatCurrency(balances.filter(bal => 
                                        bal.particulars == `Total Long Term Liabilities`)[0].value)
                                    :
                                    '0.00'
                                }}
                            </th>
                        </tr>
                    </thead>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                TOTAL LIABILITIES</th>
                            <th class="py-tiny whitespace-nowrap">
                                {{
                                    balances.filter(bal => bal.particulars == `TOTAL LIABILITIES`).length
                                    ?
                                    $formatCurrency(balances.filter(bal => 
                                        bal.particulars == `TOTAL LIABILITIES`)[0].value)
                                    :
                                    '0.00'
                                }}
                            </th>
                        </tr>
                    </thead>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                NET ASSETS</th>
                            <th class="py-tiny whitespace-nowrap">
                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-gray-100 text-sm border-b-2">
                        <tr class="border-b-2" 
                            v-for="(balance, idx) in balances.filter(bal => bal.particulars == `Profit of the Year`)" 
                            :key="`_0212_${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="py-tiny">
                                {{ balance.particulars }}
                            </td>
                            <td class="py-tiny">
                                {{ balance.value ? $formatCurrency(balance.value) : 0.00 }}
                            </td>
                        </tr>
                    </tbody>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                TOTAL LIABILITIES AND STOCKHOLDERS EQUITY</th>
                            <th class="py-tiny whitespace-nowrap">
                                {{
                                    balances.filter(bal => bal.particulars == `TOTAL LIABILITIES AND STOCKHOLDERS EQUITY`).length
                                    ?
                                    $formatCurrency(balances.filter(bal => 
                                        bal.particulars == `TOTAL LIABILITIES AND STOCKHOLDERS EQUITY`)[0].value)
                                    :
                                    '0.00'
                                }}
                            </th>
                        </tr>
                    </thead>
                </table>
        </div> -->
   <!-- end previous balance sheet view -->

      <table class="table table-hover">
            <thead class="bg-blue-500 text-xs text-white">
                <tr class="flex w-full">
                    <th class="p-tiny w-2/6">Balance Sheet </th>
                
                     <th class="p-tiny  w-1/6 text-right" v-for="grp in groups" :key="grp">Value</th>
                </tr>
            </thead>
            <tbody class="flex flex-col items-center text-xs bg-gray-100 overflow-auto" style="height:70vh;">
                <tr class="w-full flex" v-for="(particular, idx) in bls.particulars" :key="idx">
               
                    <td class="p-tiny w-2/6">  
                        <div :class="{
                            'ml-1 font-bold':  particular.orderVal== 0 ,
                           'ml-1 font-bold text-black-600 ':  particular.orderVal== 1 ,
                            'ml-3 font-bold':  particular.orderVal== 2,
                            'ml-8':  particular.orderVal== 3,
                            'ml-1 font-bold': particular.orderVal== 4,
                            
                        }">
 {{ particular.name }} 
                        </div>   
                        <!-- <p :class="particular.orderVal==1? classorder.class1: particular.orderVal==2? classorder.class2: particular.orderVal==3? classorder.class3: particular.orderVal==4? classorder.class4: classorder.class0"> {{ particular.name }}{{particular.orderVal}}</p> -->
                        </td>
                    <td class="p-tiny  w-1/6 text-right" v-for="grp in groups" :key="grp">
                    <div :class="{
                             'mr-1 font-bold underline':  particular.orderVal== 1 ,
                             'mr-3 font-bold underline':  particular.orderVal== 2,
                             'mr-5':  particular.orderVal== 3,
                             'mr-1': particular.orderVal== 4,
                            
                        }">
 {{ 
                                    bls.balanceSheetDetails.filter(pl => 
                                        pl.particulars == particular.name && pl.groupId==grp ).length ? 
                                      particular.orderVal==0 || particular.orderVal==4?'':  $formatCurrency(bls.balanceSheetDetails.filter(pl => 
                                            pl.particulars == particular.name  && pl.groupId==grp)[0].value) : `-` 
                                }}
                        </div>  
                    </td>
                     
                </tr>
            </tbody>
        </table>
   </div>
</template>